import { gql } from "@apollo/client";

export const importPipelineQuery = gql`
  query ImportPipeline {
    importPipeline {
      templateUrl
      steps {
        sheetName
        displayName
        position
        dependsOn
        fieldPreview {
          name
          description
          required
        }
      }
    }
  }
`;

export const importFileStatusQuery = gql`
  query ImportFileStatus($id: ID!) {
    importFile(id: $id) {
      id
      status
      resultUrl
      resultSummary {
        sheet
        rowsOk
        rowsSkipped
        rowsError
        sheetMissing
        errorMessages
        skipMessages
      }
    }
  }
`;
